<h2 class="sub-header-bar">Supplier Adhoc Invoices</h2>
<div class="ui-g adhoc-invoice-section">
  <div class="ui-g-12" style="position: relative; padding: 0">
    <form *ngIf="showFilterPane" (ngSubmit)="search()">
      <div class="ui-g filterPanel">
        <div class="ui-g-12 ui-md-3 ui-lg-3">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.from.value"
              name="invoiceDateFrom"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>From</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-3 ui-lg-3">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.to.value"
              name="invoiceDateTo"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>To</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-3 ui-lg-3">
          <span class="md-inputfield filterItem">
            <p-dropdown
              name="supplier"
              [options]="invoiceSuppliers"
              [(ngModel)]="filterVal.filters.organisationId.value"
              filter="true"
              placeholder="Select a supplier"
            ></p-dropdown>
          </span>
        </div>

        <div class="ui-g-12 ui-md-3 ui-lg-3">
          <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
          <button
            pButton
            type="button"
            label="Clear"
            class="ui-button btn-to-right ui-button-tertiary"
            (click)="clearFilter(dt)"
          ></button>
        </div>
      </div>
    </form>
    <br />

    <p-treeTable
      #dt
      [value]="page.items"
      [columns]="cols"
      [paginator]="false"
      [rows]="100"
      [lazy]="true"
      (onLazyLoad)="onGridLazyLoad($event)"
      [totalRecords]="page.total"
      [loading]="isLoading"
      [resizableColumns]="true"
      [rowsPerPageOptions]="[5, 10, 20]"
      class="adhoc-invoice-tree-table"
      selectionMode="checkbox"
      [(selection)]="selectedTransactions"
    >
      <ng-template pTemplate="caption">
        <div style="text-align: left">
          <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
          <span style="margin-left: 0.25em; vertical-align: middle">Toggle All</span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            *ngFor="let col of columns"
            [ttSortableColumn]="col.field"
            ttResizableColumn
            [style.width]="col.width"
            [ngClass]="{ collapsible: col.field != 'jobNumber' }"
          >
            {{ col.header }}
            <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
        <tr class="transaction-lines-tr">
          <td
            *ngFor="let col of columns"
            [ngSwitch]="col.field"
            [ngClass]="{ collapsible: col.field != 'jobNumber' }"
          >
            <div *ngSwitchCase="'jobNumber'" [ngClass]="{ typography: true }">
              <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
              <p-treeTableCheckbox [value]="rowNode"></p-treeTableCheckbox>
              {{ rowData[col.field] }}

              <div class="visibility-sm">
                | <i> {{ rowData.createdDateTime | datex : "DD MMM 'YY" }} </i> |
                <b>{{ rowData.amount | currency : 'GBP' : 'symbol' : '1.2-2' }}</b
                ><br />
                <p>{{ rowData.description }}</p>
              </div>
            </div>
            <div *ngSwitchCase="'lastUpdated'">
              {{ rowData[col.field] | datex : 'DD MMM YYYY' }}
            </div>
            <div *ngSwitchCase="'createdDateTime'">
              {{ rowData[col.field] | datex : 'DD MMM YYYY' }}
            </div>
            <div *ngSwitchCase="'description'" [ngClass]="{ typography: true }">
              {{ rowData[col.field] }}
            </div>
            <div *ngSwitchCase="'amount'">
              {{ rowData[col.field] | currency : 'GBP' : 'symbol' : '1.2-2' }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-treeTable>
  </div>

  <div class="clearfix"></div>
  <br />
  <p-panel
    class="ui-g-12 ui-md-offset-7 ui-md-5 ui-lg-offset-8 ui-md-4"
    *ngIf="selectedTransactions.length > 0"
  >
    <p-header>
      <div class="ui-helper-clearfix">
        <span class="ui-panel-title">Selection Summary</span>
      </div>
    </p-header>

    <div class="summary-div">
      <table class="invoice-view-totals" cellpadding="0" cellspacing="0">
        <tr>
          <td>Transactions</td>
          <td>{{ getSelectedTransactionsLinesTotal() }}</td>
        </tr>
        <tr>
          <td>Amount</td>
          <td>{{ getSelectedTransactionTotalAmount() | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
        </tr>
      </table>
      <br />
      <button
        class="pull-right"
        pButton
        type="button"
        icon="pi pi-plus"
        label="Generate Invoice"
        [disabled]="invoiceButtonDisbaled"
        (click)="generateInvoice()"
      ></button>
    </div>
  </p-panel>
</div>
